import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Parasitologist icon
 *
 * @category Medical
 */
const Parasitologist = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M15.656 5.01c-5.59-.06-10.61 4.68-10.88 10.26-.66 12.54 16.6 16.34 21.25 4.66 2.86-6.85-2.76-15.08-10.18-14.92h-.2zm-.1 21.07c-13.51-.77-12.43-20.49 1.03-19.95 12.59 1.32 11.78 19.62-.83 19.95z"
        />
        <path
          fill="currentColor"
          d="M18.7 21.274c0-.4-.58-1.27-.43-2.19.05-.49.1-.99.01-1.47-.18-.95-.74-1.96-.29-2.92.51-1.14 1.75-1.91 2.06-3.13.21-.82-.23-1.64-.98-1.95-2.33-.58-4.11 1.4-5.33 3.63-.36.76-.57 1.67-1.01 2.36-.49.85-1.43 1.22-2.11 1.7-.39.25-.79.8.05.81.91.03 2.25-1.51 3.08-1.1.84.3.56 2.13.21 2.78-.4.82-1.11 1.39-.88 2.35.17.75.84 1.77 1.35 1.77.35 0 .53-.44.23-.9-.27-.43-.67-1.07-.48-1.59.34-.85 1.36-1.74 1.22-3.1-.09-.91.75-1.58 1.13-1.61.55.04.6 1.69.5 2.43-.13.75-.09 1.56.55 2.01.28.2.89.5 1.11.17v-.06zm-4.01-4.59c-1.88-1.29.83-4.81 2.25-5.65.57-.4 1.92-.82 1.98.2.01.79-1.12 1.86-1.81 2.88-.67.85-1.11 2.46-2.3 2.59z"
        />
      </svg>
    );
  }
);

Parasitologist.displayName = 'Parasitologist';

export { Parasitologist };
